import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { PartnerGroup } from 'src/app/shared/models/partner-group';
import { PartnerGroupMember } from 'src/app/shared/models/partner-group-member';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-add-partner-group-modal',
  templateUrl: './add-partner-group-modal.component.html',
  styleUrls: ['./add-partner-group-modal.component.scss']
})
export class AddPartnerGroupModalComponent implements OnInit {

  newPartnerGroupName: string;
  partners: Partner[] = [];

  availablePartners: { selected: boolean, partner: Partner }[];

  constructor(private userService: UserService, private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<AddPartnerGroupModalComponent>) { }

  ngOnInit(): void {

    this.partnerService.getPartners().subscribe(x => {
      this.partnerService.setPartners(x);

      //get list of partners
      this.partnerService.partners$.subscribe((x) => {
        this.partners = x;

        this.availablePartners = this.partners.map((partner, index) => {
          return {
            selected: false,
            partner: partner
          };
        });
      });

    });


  }

  onClose(): void {
    this.dialogRef.close();
  }

  addNewPartnerGroup() {

    // set mibe music partner to selected (HTML [checked] does not seem to do this, only makes the visual check)
    this.availablePartners = this.availablePartners.map(partner => ({
      ...partner,
      selected: partner.partner.name.toLowerCase() === 'mibe music' ? true : partner.selected
    }));

    let selectedPartners = this.availablePartners.filter(partner => partner.selected === true);

    if (selectedPartners.length > 0) {

      //create the partner group
      //name is all partners' names
      //Mibe will be added to the group on the backend

      //sort selectedPartners by name - keeps stored name to a format
      selectedPartners.sort((a, b) => {
        if (a.partner.name < b.partner.name) {
          return -1;
        }
        if (a.partner.name > b.partner.name) {
          return 1;
        }
        return 0;
      });

      //build the group name
      //note, name likely won't actually be used for display
      //but rather used to prevent duplicate groups
      // let name = '';
      // selectedPartners.forEach(partner => {
      //   name += partner.partner.name.toLowerCase() + ' ';
      // });

      //remove trailing white space
      // name = name.trimEnd();

      const name = this.newPartnerGroupName;
      //create group
      let group: PartnerGroup = {
        id: null,
        name: name,
        members: [],
        shows: [],
        episodes: [],
        selectedEpisodesCount: null
      };

      this.partnerService.addNewPartnerGroup(group, this.userService.currentUser.id).subscribe(
        (resGroup) => {

          //create group member for each partner in group
          let addedCount = 0;

          selectedPartners.forEach(partner => {
            let member: PartnerGroupMember = {
              id: 0,
              allocationPercentage: 0,
              partnerId: partner.partner.id,
              partnerGroupId: resGroup.id,
              partner: partner.partner,
              postDilution: false,
              // episodes: [],
              postDilutionParentId: null,
              postDilutionChildren: [],

              //selectedEpisodesCount: 0,
              expandDetails: false,
            };
            if (partner.partner.name.toLowerCase() == 'mibe music') {
              member.allocationPercentage = 100;
            }

            this.partnerService.addNewPartnerGroupMember(member, this.userService.currentUser.id).subscribe(
              (resMember) => {

                //track count - once complete, show success message
                addedCount++;

                if (addedCount == selectedPartners.length) {
                  //call snackbar for success message
                  this.snackbarService.showSnackBarMessage("Partner Group successfully created!", 'Close')

                  this.onClose();
                }
              },
              (error) => {
                //an error occurred added a partner to the group

                //call snackbar for error message
                this.snackbarService.showSnackBarMessage("An error occurred while attempting to create the partner group.", 'Close', undefined, true);
              })
          })


        },
        (error) => {

          if (error.error.error.toLowerCase().includes('duplicate key value violates')) {
            this.snackbarService.showSnackBarMessage("Partner group may already exist. Please review selected partners.", 'Close', undefined, true);
          }
          else {
            //call snackbar for error message
            this.snackbarService.showSnackBarMessage("An error occurred while attempting to create the partner group.", 'Close', undefined, true);
          }

        }
      );
    }
    else {
      //call snackbar to display error message
      this.snackbarService.showSnackBarMessage("You must select at least 1 partner to start a new group", 'Close', undefined, true);

    }


  }

}
